import { Box, CircularProgress, IconButton, SxProps, Tooltip, useTheme } from '@mui/material';
import { FC } from 'react';

import { Workflow } from '@apiContract';
import { tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';
import { CapturePiece } from '@components/Capture/types';
import path from 'lodash/fp/path';

import { BarcodeIcon } from '@src/assets/icons/BarcodeIcon';
import { getBarcodeIconColor } from '@utils/annotations';

interface IBarcodeLocalIconProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
  workflow?: Workflow;
  disabled?: boolean;
}

const BarcodeLocalIcon: FC<IBarcodeLocalIconProps> = ({ onClick, capturePiece, disabled: disabledProp }) => {
  const theme = useTheme();
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;

  const color =
    capturePiece.piece?.pieceSummary && !piece?.pieceSummary?.inProgressTrackingNumberDetection
      ? getBarcodeIconColor(capturePiece?.piece)
      : undefined;

  const themeColor = color ? path(['palette', color, 'main'], theme) : undefined;
  const isLoading =
    piece?.pieceSummary?.inProgressTrackingNumberDetection || piece?.pieceSummary?.inProgressLockerAnnouncement;
  const disabled = !piece || disabledProp;

  return (
    <Tooltip title={tooltips.Barcode} arrow>
      <Box component="span">
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={tooltips.Barcode}
          sx={{ ...CommonStyles, ...sxMR0 } as SxProps}
        >
          <BarcodeIcon sx={StyledIcon(disabled ? 'action.disabled' : themeColor)} />
          {isLoading && <CircularProgress />}
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export { BarcodeLocalIcon };
